import { useParams } from "react-router-dom";
import AuditEvents from "../../components/AuditEvents";

const Entity = () => {
  let { entityType, entityId } = useParams();

  if (!entityType || !entityId) {
    return <div>Entity type or ID is missing</div>;
  }

  return <AuditEvents entityType={entityType} entityId={entityId} />;
};

export default Entity;
